export const queryKeys = {
  // Organization Settings
  organizationSettings: ['organization', 'settings'] as const,

  // Privacy Content
  privacyContent: ['privacy', 'content'] as const,
  aboutUs: ['privacy', 'aboutUs'] as const,
  dataPractice: ['privacy', 'dataPractice'] as const,

  // Privacy Actions
  privacyActions: ['privacy', 'actions'] as const,

  // Preferences
  preferences: ['preferences'] as const,

  // Tab Configuration
  tabConfiguration: ['tabConfiguration'] as const,

  // DSR Type Options
  dsrTypeOptions: ['dsrTypeOptions'] as const,

  // Consent Management
  consentManagement: (email: string) => ['consentManagement', email] as const,

  // Data Subject Requests
  dsrByEmail: (email: string) => ['dsr', 'byEmail', email] as const,

  // Geography
  countries: ['geography', 'countries'] as const,
  states: (countryId: string) => ['geography', 'states', countryId] as const,
  countryCallingInfo: ['geography', 'callingCodes'] as const,

  // Inaccuracy Mapping
  inaccuracyMapping: ['inaccuracyMapping'] as const,
} as const;
